import { SET_TEMP_DATA } from "../action-types";

const initialState = {
    username: null,
    password: null
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_TEMP_DATA: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
}
